"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import RecruitApiClient from "../../RecruitApiClient";
class Api {
  constructor() {
    this.getCandidateData = (candidateId) => RecruitApiClient.get(`/api/v4/candidates/${candidateId}`, null);
    this.updateCandidateTags = (candidateId, tags, entityId = null) => __async(this, null, function* () {
      let response = null;
      if (entityId) {
        response = yield RecruitApiClient.post(`/api/v4/candidates/${candidateId}/update_tags`, {
          entity_id: entityId,
          tags
        });
      } else {
        response = yield RecruitApiClient.post(`/api/v4/candidates/${candidateId}/update_tags`, {
          tags
        });
      }
      return response;
    });
    this.getCandidateApplications = (candidateId, params) => RecruitApiClient.get(`/api/v4/candidates/${candidateId}/applications`, params);
    this.getCandidateTasks = (candidateId) => RecruitApiClient.get(`/api/v4/candidates/${candidateId}/tasks`);
    this.getAssignableUsers = () => RecruitApiClient.get(`/api/v4/tasks/assignable_users`);
    this.createCandidateTask = (candidateId, params) => RecruitApiClient.post(`/api/v4/candidates/${candidateId}/tasks`, params);
    this.deleteCandidateTask = (candidateId, taskId) => RecruitApiClient.delete(`/api/v4/candidates/${candidateId}/tasks/${taskId}`);
    this.updateCandidateTask = (candidateId, taskId, params) => RecruitApiClient.put(`/api/v4/candidates/${candidateId}/tasks/${taskId}`, params);
    this.getWorkflows = (candidateId) => RecruitApiClient.get(`/api/v4/workflows?candidate_id=${candidateId}`);
    this.assignWorkflow = (candidateId, params) => RecruitApiClient.post(`/api/v4/workflows?candidate_id=${candidateId}`, params);
    this.getCandidateActivities = (candidateId) => RecruitApiClient.get(`/api/v4/candidates/${candidateId}/activities`);
    this.addCandidateNote = (candidateId, params) => RecruitApiClient.post(`/api/v4/candidates/${candidateId}/add_permanent_record`, {
      note: params
    });
    this.mergeCandidates = (candidateId) => RecruitApiClient.post(`/api/v4/candidates/${candidateId}/merge`);
    this.updateCandidateNotepad = (candidateId, body) => RecruitApiClient.put(`/api/v4/candidates/${candidateId}/update_notepad`, { body });
  }
}
export default new Api();
